import {
    Box,
    Button,
    Chip,
    Tab,
    Tabs,
    Typography
} from '@mui/material';

import { Add as AddIcon } from '@mui/icons-material';
import { InviteUsersDialog } from './InviteUsersDialog';
import { PendingInvitationsTab } from './PendingInvitationsTab';
import { TeamMembersTab } from './TeamMembersTab';
import { usePageDefaultStyle } from '../../assets/style/usePageDefaultStyle';
import { useState } from 'react';
import { useTeamManagement } from './useTeamManagement';

enum TeamManagementTab {
    MEMBERS = 0,
    INVITATIONS = 1
}

export const TeamDashboard = () => {
    const [isInviteDialogOpen, setIsInviteDialogOpen] = useState(false);
    const [currentTab, setCurrentTab] = useState<TeamManagementTab>(TeamManagementTab.MEMBERS);

    const { pageDefaultStyle } = usePageDefaultStyle();
    const {
        invitations,
        isAccountOwner,
    } = useTeamManagement();

    if (!isAccountOwner) {
        return <div>You are not authorized to manage this team</div>;
    }

    return (
        <Box sx={{ ...pageDefaultStyle }}>
            <Typography variant="h3" gutterBottom>
                Team Management
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Tabs
                    value={currentTab}
                    onChange={(_, newValue) => setCurrentTab(newValue as TeamManagementTab)}
                    sx={{ mb: 1 }}
                >
                    <Tab label={<Typography variant="h6">Team Members</Typography>} />
                    <Tab
                        label={
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <Typography variant="h6">Pending Invitations</Typography>
                                {((invitations ?? []).length > 0) && (
                                    <Chip
                                        label={(invitations ?? []).length}
                                        size="small"
                                        color="primary"
                                        sx={{ ml: 1 }}
                                    />
                                )}
                            </Box>
                        }
                    />
                </Tabs>
                <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={() => setIsInviteDialogOpen(true)}
                    sx={{ maxHeight: '40px' }}
                >
                    Invite Member
                </Button>
            </Box>
            {currentTab === TeamManagementTab.MEMBERS && (
                <TeamMembersTab />
            )}
            {currentTab === TeamManagementTab.INVITATIONS && (
                <PendingInvitationsTab />
            )}
            <InviteUsersDialog
                open={isInviteDialogOpen}
                onClose={() => setIsInviteDialogOpen(false)}
            />
        </Box>
    );
};
